module.exports = __webpack_public_path__ + "static/media/logo-vercan-header.2ee3d972.jpg";